export enum PAY_TYPE {
  CPM = 'cpm',
  CPC = 'cpc',
  CPI = 'cpi',
  CPL = 'cpl',
  CPA = 'cpa',
}
